import React from 'react';

import Box from 'shared/Box';
import Text from 'shared/Text';

type Props = {
  title: string;
  renderMessage?: string | React.ReactNode;
};

export const FormErrorAlert = ({ title, renderMessage }: Props) => (
  <Box
    padding={16}
    color="rgba(208, 2, 27, 0.1)"
    dangerouslySetInlineStyle={{
      borderRadius: 6,
      marginTop: 10,
    }}
  >
    <Text isBold={true} color="#e54751" align="center">
      {title}
    </Text>
    <Text color="#e54751" align="center">
      {renderMessage}
    </Text>
  </Box>
);
